<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <v-card>
      <v-toolbar color="primary" dark dense>
          <v-toolbar-title>{{currentMode == 'edit' ? 'Редактируем' : 'Новый'}} контакт сотрудника</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <contactsLine :user="user" :mode="'view'" @onContactSelected="onContactSelected" v-if="currentMode == 'create'"/>
      </v-card-title>

      <v-card-text class="mt-5">
        <v-row no-gutters>
          <v-col cols="5">
            <v-select :items="addContactItems" v-model="contType" dense class="ml-3 mr-3" @change="typeChanged"></v-select>
          </v-col>
          <v-col cols="7">
            <v-text-field
              v-model="contValue"
              dense
              class="mr-3"
              label="Значение"
              hint="Введите значение"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="d-flex align-start black--text" v-if="currentMode === 'edit'">
          <v-switch
            v-model="isMainContact"
            true-value="1"
            false-value="0"
            :label="mainLabel"
            :readonly="contMain == '1'"
            hint="Класс контакта в выбранном типе"
            persistent-hint
            color="success"
            dense
          ></v-switch>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click="onCloseEvent(null)"
        >
          Отмена
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          @click="onDeleteContact"
          :disabled="deleteDisabled"
          v-if="currentMode == 'edit'"
          class="white--text"
        >
          Удалить
        </v-btn>
        <v-btn
          color="primary"
          @click="onSaveEvent"
          :disabled="!isFormValid"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import contactsLine from '@/components/modules/org/structure/staff/userContactsLine.vue'
import { ORG_ADD_USER_CONTACT, ORG_UPD_USER_CONTACT, ORG_DEL_USER_CONTACT } from '@/store/actions/org'
import { USER_CONT_MAIN } from '@/store/actions/user'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'addUserContactDialog',
  props: ['value', 'user', 'mode'],
  components: {
    contactsLine: () => import('@/components/modules/org/structure/staff/userContactsLine.vue')
  },
  data: () => ({
    addContactItems: [
      { text: 'Адрес e-mail', value: '0' },
      { text: 'Адрес ЭДО', value: '1' },
      { text: 'Рабочий телефон', value: '2' },
      { text: 'Мобильный телефон', value: '3' }
    ],
    contValue: '',
    contType: '0',
    contMain: false,
    contID: -1,
    modeChanged: false,
    busy: false,
    realMode: null
  }),
  computed: {
    deleteDisabled: {
      get: function () {
        if (this.contMain === '1' && this.contType === '0') { return true }
        if (this.contMain === '1' && this.contType === '1') { return true }
        return false
      }
    },
    currentMode: {
      get: function () {
        if (!this.modeChanged) { return this.mode }
        return this.realMode
      }
    },
    isFormValid: {
      get: function () {
        return this.contType && this.contValue && !this.busy
      }
    },
    mainLabel: {
      get: function () {
        return this.contMain ? 'Основной' : 'Дополнительный'
      }
    },
    isMainContact: {
      get: function () {
        return this.contMain
      },
      set: function (val) {
        this.busy = true
        const payload = {
          INST_UUID: this.user.INST_UUID,
          EMP_ID: this.user.EMP_ID,
          CONT_ID: this.contID,
          CONT_TYPE: this.contType
        }
        this.$store.dispatch(USER_CONT_MAIN, payload)
          .then((resp) => {
            this.contMain = resp.CONT_IS_GEN
          })
          .catch((err) => {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка изменения контакта ' + err })
          })
          .finally(() => {
            this.busy = false
          })
      }
    }
  },
  watch: {
    mode (val) {
      console.log('Add contact dialog mode changed')
      this.realMode = val
    }
  },

  methods: {
    typeChanged (val) {
      if (this.mode === 'create') { return }
      const contact = this.user.CONTACTS.find(item => item.CONT_TYPE === val)
      if (contact) {
        this.realMode = 'edit'
        this.onContactSelected(contact)
      } else {
        this.clearForm(val)
        this.realMode = 'create'
      }
      this.modeChanged = this.mode !== this.realMode
    },
    clearForm (contType) {
      this.contValue = ''
      this.contType = contType || '0'
      this.contMain = false
      this.contID = -1
      this.realMode = null
      this.modeChanged = false
    },
    onCloseEvent (data) {
      this.clearForm()
      this.$emit('input', false)
    },
    onContactSelected (item) {
      this.contType = item.CONT_TYPE
      this.contValue = item.CONT_VALUE
      this.contMain = item.CONT_IS_GEN
      this.contID = item.CONT_ID
    },
    onSaveEvent () {
      if (this.currentMode === 'create') {
        this.onAddContact()
      }
      if (this.currentMode === 'edit') {
        this.onEditContact()
      }
    },
    onAddContact () {
      // Сохраняем данные
      console.log('Current user is ', this.user)
      const payload = {
        EMP_ID: this.user.EMP_ID,
        INST_UUID: this.user.INST_UUID,
        CONT_TYPE: this.contType,
        CONT_VALUE: this.contValue
      }
      this.$store.dispatch(ORG_ADD_USER_CONTACT, payload)
        .then((resp) => {
          this.$emit('onUserContactAdded', resp)
          this.clearForm()
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка добавления контакта ' + err })
          console.log('Ошибка ', err)
        })
    },
    onEditContact () {
      // Сохраняем данные
      console.log('Current user is ', this.user)
      const payload = {
        CONT_ID: this.contID,
        EMP_ID: this.user.EMP_ID,
        INST_UUID: this.user.INST_UUID,
        CONT_TYPE: this.contType,
        CONT_VALUE: this.contValue
      }
      this.$store.dispatch(ORG_UPD_USER_CONTACT, payload)
        .then((resp) => {
          this.$emit('onUserContactUpdated', resp)
          this.clearForm()
          this.$emit('input', false)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка обновления контакта ' + err })
          console.log('Ошибка ', err)
        })
    },
    onDeleteContact () {
      // Сохраняем данные
      console.log('Current user is ', this.user)
      const payload = {
        CONT_ID: this.contID,
        EMP_ID: this.user.EMP_ID,
        CONT_TYPE: this.contType,
        INST_UUID: this.user.INST_UUID
      }
      this.$store.dispatch(ORG_DEL_USER_CONTACT, payload)
        .then((resp) => {
          this.$emit('onUserContactDeleted', resp)
          this.clearForm()
          this.$emit('input', false)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка удаления контакта ' + err })
          console.log('Ошибка ', err)
        })
    }
  }

}
</script>
